import { useTranslations } from "next-intl";
import { DataField, Stack } from "@leabankab/component-library";
import { SummarySection } from "@/components/ui";
import { useCurrency } from "@/hooks";
import { toAmount } from "@/shared/amount";
import { SummaryPageContext } from "../../types";

interface Props {
	context: SummaryPageContext;
}

export const InsuranceList = ({ context }: Props) => {
	const t = useTranslations("pages.SummaryPage");
	const { format } = useCurrency();
	const hasInsurance =
		"offer" in context ? context.hasInsurance : context.insurance;

	if (!hasInsurance) return null;

	// FLOW defaults a missing premium to 0, which is not a price to show.
	const insuranceCost =
		"offer" in context ? toAmount(context.offer.insuranceCost) : null;

	return (
		<SummarySection title={t("additions.header")}>
			<Stack>
				<DataField
					label={t("additions.content.insurance")}
					value={insuranceCost ? format(insuranceCost) : t("additions.added")}
					divider={false}
				/>
			</Stack>
		</SummarySection>
	);
};
